// extracted by mini-css-extract-plugin
module.exports = {"noEvents":"NoEvents_noEvents__2im8C","icon":"NoEvents_icon__3VEPg"};